import { create } from 'zustand';

/**
 * Client-side map of sent command id → kind. `CommandAck` only carries the
 * id, so the results feed needs this to say WHAT was acked. Session-local by
 * design — an ack for a command sent before a reload just shows its id tail.
 */
const SENT_MAX = 200;

interface CommandLogStore {
  kinds: Record<string, string>;
  order: string[];
  record: (id: string, kind: string) => void;
}

export const useCommandLog = create<CommandLogStore>((set) => ({
  kinds: {},
  order: [],
  record: (id, kind) =>
    set((s) => {
      const kinds = { ...s.kinds, [id]: kind };
      const order = [...s.order, id];
      while (order.length > SENT_MAX) {
        const drop = order.shift()!;
        delete kinds[drop];
      }
      return { kinds, order };
    }),
}));
